import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import AppHeader from "./AppHeader";
import { useAuth } from "../../hooks/useAuth";
import Loader from "../../components/loading/Loader";

export default function ChatLayout() {
  const navigate = useNavigate();
  const { userInfo } = useAuth();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!userInfo?.id) navigate(`/login`);
    setIsLoading(false);
  }, [userInfo, navigate]);

  if (isLoading) return <Loader />;

  return (
    <div>
      <AppHeader />
      <main className="flex-1 flex flex-col">
        <Outlet />
      </main>
    </div>
  );
}
